import { useParams } from 'react-router';
import { Empty, Loading, ViewLayout } from '@lithos';
import { DatasetFCO, WorkspaceFCOContainer } from '../../../core/types/fcoTypes';

import { useGetFcos } from '../../../api/fcos';
import { useGetDatasets } from '../../../api/datasets';
import DataSetsList from './DatasetsList';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';

const DatasetsListContainer = () => {
  const { workspace } = useParams();

  // eslint-disable-next-line prefer-const
  let { data: datasetsData, isLoading: datasetsIsLoading, error: dataSetsError } = useGetDatasets(workspace as string);
  const {
    data: fcoData,
    isLoading: fcosAreLoading,
    error: fcoError,
  } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        featureViews: data.featureViews,
        featureServices: data.featureServices,
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: {
        label: workspace ?? '',
        url: `/repo/${workspace}`,
      },
      items: [
        {
          label: 'Datasets',
        },
      ],
    },
    title: 'Datasets',
    subtitle: 'Datasets save feature data for use in model training and analysis.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.DATASETS,
  };

  if (fcosAreLoading || datasetsIsLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  if (fcoError || dataSetsError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            title={<>Error Loading Datasets</>}
            description={<>There was an error loading Datasets for this workspace. Please try again.</>}
            useCase="errorUnknown"
            placement="full-page"
            actions={undefined}
          />
        }
      />
    );
  }

  const emptyDatasets: DatasetFCO[] = [];

  if (datasetsData === undefined) {
    datasetsData = { data: emptyDatasets };
  }

  return (
    <ViewLayout
      header={headerProps}
      content={<DataSetsList items={datasetsData.data} idToFcoMap={fcoData.idToFcoMap} workspace={workspace ?? ''} />}
    />
  );
};

export default DatasetsListContainer;
